module.exports = __webpack_public_path__ + "static/media/HCMM152.59518469.jpg";